var Modal = (function($, undefined) {

    function Modal(id, options) {
        var self = this;
        self.id = '#' + id;
        if ($(self.id)[0] === undefined) {
            Modal.createForm(id);
        }
        self.options = $.extend({}, Modal.defaultOptions, options);
        self.title(self.options.title);
        if (self.options.url != null) {
            $(self.id).find("#loadingModalBody").show();
            $.get(self.options.url)
                .done(function(html) {
                    self.body(html);
                    $(self.id).find("#loadingModalBody").hide();
                });
        } else {
            self.body(self.options.body);
        }
        self.cancelText(self.options.cancelText);
        self.acceptText(self.options.acceptText);
        self.showCancelButton(self.options.showCancelButton);
        self.showAcceptButton(self.options.showAcceptButton);
        self.cancelCallback = self.options.cancelCallback;
        self.acceptCallback = self.options.acceptCallback;
        $(self.id).modal({ show: false });
        $(self.id).find('.modal-cancel').click(function () { self.cancelCallback(); });
        $(self.id).find('.modal-accept').click(function () { self.acceptCallback(); });
        if (self.options.isLarge)
            $(self.id).find('.modal-dialog').addClass('modal-lg');

        var acceptButtonHidden = $(self.id).find('.modal-acceptButton').css('display') == 'none';
        var cancelButtonHidden = $(self.id).find('.modal-cancelButton').css('display') == 'none';
        if (acceptButtonHidden && !cancelButtonHidden) {
            $('.modal-cancelButton').addClass('col-xs-12 col-sm-3 col-sm-offset-9');
        } else if (!acceptButtonHidden && cancelButtonHidden) {
            $('.modal-acceptButton').addClass('col-xs-12 col-sm-3 col-sm-offset-9');
        } else {
            $('.modal-acceptButton').addClass('col-xs-6 col-sm-3 col-sm-offset-6');
            $('.modal-cancelButton').addClass('col-xs-6 col-sm-3');
        }

        if (self.options.acceptButtonShouldNotCloseModal) {
            $('.modal-accept').removeAttr('data-dismiss');
        }
    }

    Modal.defaultOptions = {
        title: '',
        body: '',
        url: null,
        cancelText: 'No',
        acceptText: 'Yes',
        showCancelButton: true,
        showAcceptButton: true,
        acceptButtonShouldNotCloseModal: false,
        cancelCallback: function() {},
        acceptCallback: function () { },
        isLarge: false
    };

    Modal.prototype.show = function() {
         $(this.id).modal('show');
    };

    Modal.prototype.hide = function() {
        $(this.id).modal('hide');
    };

    Modal.prototype.option = function (property, value) {
        if (value !== undefined)
            this.set(property, value);
        return this.options[property];
    }

    Modal.prototype.set = function (property, value) {
        this.options[property] = value;
        var element = $(this.id).find('.modal-' + property)[0];
        if (element != undefined)
            $(element).html(value);
        if (property === 'showCancelButton') {
            var $cancelText = $(this.id).find('.modal-cancelButton').show();
            if (value) $cancelText.show();
            else $cancelText.hide();
        }
        if (property === 'showAcceptButton') {
            var $acceptText = $(this.id).find('.modal-acceptButton').show();
            if (value) $acceptText.show();
            else $acceptText.hide();
        }
    }

    Modal.prototype.title = function(value) { return this.option('title', value); }
    Modal.prototype.body = function (value) { return this.option('body', value); }
    Modal.prototype.cancelText = function(value) { return this.option('cancelText', value); }
    Modal.prototype.acceptText = function(value) { return this.option('acceptText', value); }
    Modal.prototype.showCancelButton = function (value) { this.option('showCancelButton', value); }
    Modal.prototype.showAcceptButton = function (value) { this.option('showAcceptButton', value); }

    Modal.createForm = function(id) {
        $('body').append(
            '<div class="modal fade" tabindex="-1" id="' + id +'">' +
            '   <div class="modal-dialog">' +
            '       <div class="modal-content">' +
            '           <div class="modal-header">' +
            '               <button type="button" class="close modal-cancel" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>' +
            '               <h3 class="modal-title"></h3>' +
            '           </div>' +
            '           <div class="modal-body"><div id="loadingModalBody" class="text-center" style="display: none;"><img alt="Loading..." src="//assets.stullercloud.com/web/static/i/ajaxloaders/small-ajax-loader.gif" /></div></div>' +
            '           <div class="modal-footer">' +
            '               <div>' +
            '                   <div class="modal-acceptButton">' +
            '                       <span class="StullerButton largeButton primary">' +
            '                           <button id="modal-primaryButton" type="button" class="modal-acceptText modal-accept fullWidth" data-dismiss="modal"></button>' +
            '                       </span>' +
            '                   </div>' +
            '                   <div class="modal-cancelButton">' +
            '                       <span class="StullerButton largeButton secondary">' +
            '                           <button id="modal-secondaryButton" type="button" class="modal-cancelText modal-cancel fullWidth" data-dismiss="modal"></button>' +
            '                       </span>' +
            '                   </div>' +
            '               </div>' +
            '           </div>' +
            '       </div>' +
            '   </div>' +
            '</div>'
        );
    }                                    
    return Modal;
}(jQuery));